var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Menu extends Component {
    constructor() {
        super('Menu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#button-toggle-menu').on('click', (event, button) => {
                button.toggleClass('active');
                $('#main-menu').toggleClass('opened');
            });
            // Update cart counter
            let productsInCart = sessionStorage.getItem('products_in_cart');
            if (!productsInCart)
                productsInCart = '0';
            Menu.updateCartCounter(parseInt(productsInCart));
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'hw_get_cart_count',
                },
                dataType: 'json'
            });
            productsInCart = response.product_count;
            Menu.updateCartCounter(parseInt(productsInCart));
            this.success();
        });
    }
}
Menu.updateCartCounter = (count) => {
    sessionStorage.setItem('products_in_cart', count.toString());
    if (count > 0) {
        $('#cart-counter').removeClass('d-none');
        $('#cart-counter-number').text(count);
    }
    else {
        $('#cart-counter').addClass('d-none');
    }
};
